import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/utils";

export default function ThankYouPage() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const status = sp.get("status") || "paid";
  const [b, setB] = useState(null);
  useEffect(()=>{ api.get(`/public/bookings/${id}`).then(({data})=>setB(data)).catch(()=>{}); }, [id]);

  // Fire Meta Pixel Purchase only after a successful (paid) booking, once per
  // booking_id. Deduped via localStorage so refresh does not re-fire.
  useEffect(() => {
    if (status !== "paid" || !b || !b.id) return;
    const key = `fb_purchase_${b.id}`;
    if (localStorage.getItem(key)) return;
    if (typeof window.fbq === "function") {
      window.fbq("track", "Purchase", {
        value: Number(b.amount) || 0,
        currency: b.currency || "INR",
        content_name: b.program_name || b.program_type || "iChaitanya Program",
        content_ids: [b.id],
        contents: [{ id: b.id, quantity: 1 }],
      }, { eventID: b.id });
      localStorage.setItem(key, "1");
    }
  }, [b, status]);

  if (status !== "paid") {
    return (
      <div className="container-ic py-24 fade-up text-center" data-testid="payment-failed-page">
        <h1 className="font-serif text-5xl">Payment did not complete.</h1>
        <p className="mt-4 text-[#7E736E]">No worries — your seat can still be saved. Please retry, or reach us on WhatsApp.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/meditation-enlightenment" className="btn-primary">Retry registration</Link>
          <a href="https://wa.me/919217639689" className="btn-ghost">WhatsApp Support</a>
        </div>
      </div>
    );
  }
  return (
    <div className="container-ic py-24 fade-up text-center max-w-2xl mx-auto" data-testid="thankyou-page">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D4E4D3] text-[#2F4F2F] text-3xl">✓</div>
      <h1 className="font-serif text-5xl mt-6">Your seat is reserved.</h1>
      <p className="mt-4 text-[#7E736E]">A confirmation email with Zoom details is on its way.</p>
      {b && (
        <div className="soft-card mt-10 text-left">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div><div className="text-[#7E736E]">Program</div><div className="font-medium">{b.program_name}</div></div>
            <div><div className="text-[#7E736E]">Date / Time</div><div className="font-medium">{fmtDateTime(b.slot_datetime) || "—"}</div></div>
            <div><div className="text-[#7E736E]">Amount</div><div className="font-medium">{b.currency === "INR" ? "₹" : "$"}{b.amount}</div></div>
            <div><div className="text-[#7E736E]">Booking ID</div><div className="font-mono text-xs">{b.id}</div></div>
          </div>
        </div>
      )}
      <div className="mt-10">
        <Link to="/" className="btn-ghost">Back to home</Link>
      </div>
    </div>
  );
}
